import { useWorkspaceStore } from "../Context/store";

export function useRolePermissions() {

  const {selectedWorkspace} = useWorkspaceStore();
  const RolePermissions = selectedWorkspace?.rolesFeature
  const getRoleData = (role) => RolePermissions ?  RolePermissions?.[role] : {};
  

  const hasPermission = (userRole,permissionKey) => {
    const roleData = getRoleData(userRole);
    return Boolean(roleData?.[permissionKey]);
  };

  const getLimit = (userRole,limitKey) => {
    const roleData = getRoleData(userRole);
    return roleData?.[limitKey] ?? null;
  };

  const canManageRole = (userRole, targetRole) => {
    const roleData = getRoleData(userRole);
    return roleData?.manageRoles?.includes(targetRole) ?? false;
  };

  return {
    hasPermission,
    canManageRole,
    getLimit,
    getRoleData,
  };
}
